// extracted by mini-css-extract-plugin
export default {"table-rows":"Table_table-rows__iOA4U","title":"Table_title__u1gTG","with-title":"Table_with-title__zyb-w"};